import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]

  async copy() {
    const text = this.sourceTarget.textContent.trim()

    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text)
      } else {
        this.copyWithFallback(text)
      }
    } catch {
      this.copyWithFallback(text)
    }

    this.flashSuccess()
  }

  copyWithFallback(text) {
    const textarea = document.createElement("textarea")
    textarea.value = text
    textarea.style.position = "fixed"
    textarea.style.opacity = "0"
    document.body.appendChild(textarea)
    textarea.select()
    document.execCommand("copy")
    document.body.removeChild(textarea)
  }

  flashSuccess() {
    const button = this.buttonTarget
    const original = button.textContent
    button.textContent = "✓"
    setTimeout(() => { button.textContent = original }, 1500)
  }
}
